import React, { useState, useEffect } from 'react'
import logo from './logo.png'
import { BsInstagram } from 'react-icons/bs';
import { TbBrandDiscord } from 'react-icons/tb';
import { signOut } from 'firebase/auth';
import { auth } from '../Firebase/config';
function Header({ setIsAboutVisible }) {
    const [screenSaver, setScreenSaver] = useState(false)
    const [count, setCount] = useState(0)
    useEffect(() => {
        if (count >= 5) {
            signOut(auth)
            window.location.reload()
        }
    }, [count])

    return (
        <div className='header_container'>
            {
                screenSaver &&
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundImage: 'url("https://images.pexels.com/photos/7771216/pexels-photo-7771216.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1")', position: 'fixed', top: '0', left: '0' }}>

                    <button className='header_btn' onClick={() => { setScreenSaver(false) }}>Close</button>
                </div>
            }
            <h1 style={{ color: '#fff' }}>RadioBIG</h1>
            <div style={{ flex: '1' }}></div>
            <button className='header_btn' onClick={() => { }}>Music 1</button>
            <button className='header_btn' onClick={() => { }}>Music 2</button>
            <button className='header_btn' onClick={() => { }}>Music 3</button>
            <button className='header_btn' style={{ borderRadius: '2px' }} onClick={() => { setScreenSaver(true) }}>Screen saver</button>
        </div>
    )
}

export default Header